<template>
    <div>
        <div class="flex-con is-grow">
            <div>
                <slot>
                    <template v-if="label">{{label}}</template>
                </slot>
                <address-view
                    :address="address"
                    :show-no-address-info="showNoAddressInfo"
                />
            </div>

            <div class="flex-con is-justify-end is-start">
                <button
                    class="button is-small"
                    v-if="editable"
                    :disabled="disabled"
                    @click="editModal.open"
                >
                    <span class="icon">
                        <i class="fa fa-pencil"/>
                    </span>
                </button>
            </div>
        </div>

        <modal
            :active="editModal.active"
            :close="editModal.close"
        >
            <edit-address :value="localAddress"/>
            <div class="m-t-md has-text-right">
                <loading-button
                    class="button is-primary"
                    :loading="editModal.loading"
                    @click="updateAddress"
                >
                    Update
                </loading-button>
            </div>
        </modal>

    </div>
</template>

<script>

import AddressView from "@/components/address/AddressView.vue";
import Address from "@/views/orders/component/Address.vue";

export default {
    name : 'EditableAddress',
    components : {
        'edit-address' : Address,
        AddressView
    },
    props : {
        address : {
            type : Object,
            default : null,
            required : false,
        },
        label : {
            type : String,
            required : false,
        },
        editable : {
            type : Boolean,
            required : false,
            default : false,
        },
        disabled : {
            type : Boolean,
            required : false,
            default : false,
        },
        //if passed in, will resolve as a promise; else will emit immediately
        // (unless saving is enabled, which will also resolve as a promise)
        updateMethod : {
            type : Function,
            required : false,
        },
        showNoAddressInfo : {
            type : Boolean,
            default : true,
            required : false,
        },
    },
    data () {
        return {
            localAddress : { ...this.address },
            editModal : {
                active : false,
                loading : false,
                open : () => {
                    this.editModal.active = true;
                },
                close : () => {
                    this.editModal.active = false;
                },
            },
        };
    },
    methods : {
        updateAddress() {
            // clear firstName and lastName so that name updates properly
            this.localAddress.firstName = null;
            this.localAddress.lastName = null;

            if (this.updateMethod) {
                this.editModal.loading = true;
                this.updateMethod(this.localAddress).then(response => {
                    this.localAddress = response.data;
                    this.$notifySuccess("Address updated");
                    this.emitAndClose();
                }).finally(() => {
                    this.editModal.loading = false;
                });
            } else {
                this.emitAndClose();
            }
        },
        emitAndClose() {
            this.$emit('updated', this.localAddress);
            this.editModal.close();
        },
    },

};
</script>

<style lang="scss" scoped>
</style>
